module.exports = __webpack_public_path__ + "img/widgetcatalog-2.903ec63f.jpg";